<template>
  <rect
    x="0.8"
    y="0.8"
    width="14.4"
    height="14.4"
    rx="7.2"
    fill="white"
    stroke="#3769D6"
    stroke-width="1.6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 4C7.44772 4 7 4.44772 7 5V7H5C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9H7V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7H9V5C9 4.44772 8.55228 4 8 4Z"
    fill="#3769D6"
  />
</template>
